import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../styles';

const styles = css`
  width: 100%;
  padding: 0;
  background-color: ${colors.white};
  @media(min-width: 768px) {
    padding: 60px 0 90px 0;
  }

  .row {
    .col-lg-4:nth-child(1n) .cta-button-inner {
      border-color: ${colors.brand1};

      .box {
        background-color: ${colors.brand2};
      }

      .overlay::after {
        background-color: ${colors.body};
      }
    }

    .col-lg-4:nth-child(2n) .cta-button-inner {
      border-color: ${colors.brand1};

      .box {
        background-color: ${colors.brand2};
      }

      .overlay::after {
        background-color: ${colors.body};
      }
    }

    .col-lg-4:nth-child(3n) .cta-button-inner {
      border-color: ${colors.brand1};

      .box {
        background-color: ${colors.brand2};
      }

      .overlay::after {
        background-color: ${colors.body};
      }
    }
  }

  .cta-button-wrapper {
    width: 100%;
    height: 200px;
    background-color: ${colors.whiteDark};
    transition: all 0.3s ease-out;
    margin: 0 0 15px 0;
    @media (min-width: 992px) {
      margin: 0;
      height: 250px;
    }

    &:hover {
      .cta-button-inner .box {
        transform: scale(1.1);
        transition: all 0.5s ease-out;
      }
    }
  }

  .cta-button-inner {
    display: table;
    position: relative;
    border-bottom: 10px solid #000000;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;

    .box {
      position: absolute;
      bottom: 20px;
      left: 50%;
      margin-left: -20px;
      height: 40px;
      width: 40px;
      line-height: 40px;
      z-index: 2;
      text-align: center;
      border-radius: 50%;

      img {
        vertical-align: middle;
        display: inline-block;
        width: 12px;
        height: 13px;
      }
    }

    .overlay {
      z-index: 1;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: table-cell;
      vertical-align: middle;
      font-size: 21px;
      line-height: 1.2;
      font-weight: 800;
      color: ${colors.white};
      text-transform: uppercase;
      text-align: center;
      padding: 0 30px;
      font-family: ${typography.SansSerif};
      letter-spacing: 2px;
      text-shadow: 0 3px 10px rgba(0,0,0,0.30), 0 1px 2px rgba(0,0,0,0.50);
      transition: all .3s ease-out;
      position: relative;
      &::after {
        content:'';
        position: absolute;
        display: block;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        opacity: .4;
        z-index: -1;
        transition: all .3s ease-out;
      }
        &:hover::after {
          opacity: .5;
        }
      }
    }
`;


function CtaBanner({ page }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row justify-content-center">
          {
            page.cta_items.map(item => (
              <div className="col-lg-4" key={item.title}>
                <div className="cta-button-wrapper">
                  <Link name={item.route}>
                    <div className="cta-button-inner" style={{ backgroundImage: `url(${buildThumbnailUrl(item.image.contentUrl, { width: 500, height: 500 })})` }}>
                      <div className="box">
                        <img src="/images/btn-right-arrow.svg" alt="Right Arrow" />
                      </div>
                      <div className="overlay">
                        {item.title}
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}


CtaBanner.propTypes = {
  page: PropTypes.object,
};

CtaBanner.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'cta_banner',
})(CtaBanner);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/CtaBanner.js